// extracted by mini-css-extract-plugin
export default {"wrapper":"NavBarComponent_wrapper__e6z0N","hamburgerButton":"NavBarComponent_hamburgerButton__fvJm3","title":"NavBarComponent_title__2mujj"};